class WLSNCompareAidsV2 extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      compareData: 'js-wlsn-compare-aids-v2-compare-data',
      dropdown: 'js-wlsn-compare-aids-v2-dropdown',
      column: 'js-wlsn-compare-aids-v2-column-content',
      cell: 'js-wlsn-compare-aids-v2-cell',
      link: 'js-wlsn-compare-aids-v2-link',
      price: 'js-wlsn-compare-aids-v2-price',
      label: 'js-wlsn-compare-aids-v2-badge',
      saleBanner: 'js-wlsn-compare-aids-v2-sale-banner',
      subtitle: 'js-wlsn-compare-aids-v2-subtitle',
      subtitleSecondary: 'js-wlsn-compare-aids-v2-subtitle-secondary',
      subtitleTertiary: 'js-wlsn-compare-aids-v2-subtitle-tertiary',
      cellTitle: 'js-wlsn-compare-aids-v2-cell-title',
      cellDescription: 'js-wlsn-compare-aids-v2-cell-description',
      cellIcon: 'js-wlsn-compare-aids-v2-cell-image',
      cellIconWrapper: 'js-wlsn-compare-aids-v2-cell-image-wrapper'
    };

    this.selectors = {
      compareData: this.querySelectorAll(`.${this.classes.compareData}`),
      dropdowns: this.querySelectorAll(`.${this.classes.dropdown}`),
    };
  }

  connectedCallback() {
    this.initDropdowns();
    this.updateColumnsForMobile();
    window.addEventListener('resize', () => this.updateColumnsForMobile());
  }

  initDropdowns() {
    const dropdowns = this.selectors.dropdowns;

    dropdowns.forEach((dropdown) => {
      const columnEl = dropdown.closest(`.${this.classes.column}`);
      if (!columnEl) return;

      const currentLink = columnEl.querySelector(`.${this.classes.link}`);
      const currentHandle = currentLink?.dataset.productHandle || null;

      if (currentHandle) {
        const optionToSelect = Array.from(dropdown.options).find(
          (opt) => opt.value === currentHandle
        );
        if (optionToSelect) optionToSelect.selected = true;
      }

      dropdown.addEventListener('change', (event) => {
        const selectedHandle = event.target.value;
        this.updateColumn(columnEl, selectedHandle);
      });
    });
  }

  updateColumn(columnEl, productHandle) {
    const rawData = this.querySelector(
      `.${this.classes.compareData}[data-product-handle="${productHandle}"]`
    );
    if (!rawData) return;

    const data = JSON.parse(rawData.textContent);
    if (!data) return;

    if (data.background_color && data.background_color.trim() !== '') {
      columnEl.style.backgroundColor = data.background_color;
    }

    if (data.image && data.image.trim() !== '') {
      const img = columnEl.querySelector('.js-wlsn-compare-aids-v2-image');
      if (img) {
        img.src = data.image;
        img.srcset = data.image;
        img.alt = data.title || '';
      }
    }

    const labelEl = columnEl.querySelector(`.${this.classes.label}`);
    if (labelEl) {
      if (data.badge && data.badge.trim() !== '') {
        labelEl.textContent = data.badge;
        labelEl.style.color = data.badge_color || '';
        labelEl.style.backgroundColor = data.badge_background_color || '';
        labelEl.style.display = '';
      } else {
        labelEl.style.display = 'none';
      }
    }

    const saleBannerEl = columnEl.querySelector(`.${this.classes.saleBanner}`);
    if (saleBannerEl) {
      if (data.sale_banner_text && data.sale_banner_text.trim() !== '') {
        saleBannerEl.textContent = data.sale_banner_text;
        saleBannerEl.style.color = data.sale_banner_text_color || '';
        saleBannerEl.style.backgroundColor = data.sale_banner_background_color || '';
        saleBannerEl.style.display = 'flex';
      }
      else {
        saleBannerEl.style.display = 'none';
        saleBannerEl.textContent = '';
      }
    }

    const priceEl = columnEl.querySelector(`.${this.classes.price}`);
    if (priceEl) {
      priceEl.innerHTML = data.price && data.price.trim() !== '' ? data.price : '-';
    }

    const subtitleEl = columnEl.querySelector(`.${this.classes.subtitle}`);
    if (subtitleEl) {
      subtitleEl.innerHTML = data.subtitle && data.subtitle.trim() !== '' ? data.subtitle : '';
    }

    const subtitleSecondaryEl = columnEl.querySelector(`.${this.classes.subtitleSecondary}`);
    if (subtitleSecondaryEl) {
      subtitleSecondaryEl.innerHTML = data.subtitle_secondary && data.subtitle_secondary.trim() !== '' ? data.subtitle_secondary : '';
    }

    const subtitleTertiaryEl = columnEl.querySelector(`.${this.classes.subtitleTertiary}`);
    if (subtitleTertiaryEl) {
      subtitleTertiaryEl.innerHTML = data.subtitle_tertiary && data.subtitle_tertiary.trim() !== '' ? data.subtitle_tertiary : '';
    }

    const linkEl = columnEl.querySelector(`.${this.classes.link}`);
    if (linkEl) {
      if (data.url && data.url.trim() !== '') {
        linkEl.href = data.url;
        linkEl.dataset.productHandle = productHandle;
        linkEl.style.display = '';
      } else {
        linkEl.style.display = 'none';
      }
    }

    const cellContainer = columnEl.querySelectorAll(`.${this.classes.cell}`);
    const cellsData = Array.isArray(data.cells) ? data.cells : [];

    cellContainer.forEach((cellEl, i) => {
      const cellData = cellsData[i];

      const imgWrapper = cellEl.querySelector(`.${this.classes.cellIconWrapper}`);
      if (imgWrapper) {
        imgWrapper.innerHTML = '';
        if (cellData && cellData.image && cellData.image.trim() !== '') {
          const img = document.createElement('img');
          img.className = 'wlsn-compare-aids-v2__table-column-cell-image js-wlsn-compare-aids-v2-cell-image';
          img.src = cellData.image;
          img.alt = cellData.title || '';
          imgWrapper.appendChild(img);
        }
      }

      const text = cellEl.querySelector(`.${this.classes.cellTitle}`);
      if (text) {
        text.textContent = cellData && cellData.title && cellData.title.trim() !== '' 
          ? cellData.title 
          : '-';
      }

      const description = cellEl.querySelector(`.${this.classes.cellDescription}`);
      if (description) {
        description.textContent = cellData && cellData.description && cellData.description.trim() !== '' 
          ? cellData.description 
          : '-';
      }
    });
  }

  updateColumnsForMobile() {
    const isMobile = window.innerWidth <= 1023;
    const columns = this.querySelectorAll(`.${this.classes.column}`);

    columns.forEach((col, i) => {
      if (isMobile) {
        col.style.display = i === 0 || i === 1 ? 'block' : 'none';
      } else {
        col.style.display = 'block';
      }
    });
  }
}

customElements.define('wlsn-compare-aids-v2', WLSNCompareAidsV2);
 